/**
 * cart-visual.js
 * Estrutura baseada na referência Zerezes:
 * Desktop: [imagem | coluna-conteudo]
 *          coluna-conteudo: [info | preço | ação] por linha
 * Mobile:  [imagem topo] [linhas abaixo]
 */
 
(function () {
  'use strict';
 
  const SELECTORS = {
    table: '.cart-items__table',
    group: 'tbody.cart-group',
    mainRow: 'tr.cart-item--main',
    upgradeRow: 'tr.cart-item--upgrade',
    image: '.cart-items__media-image',
    title: '.cart-items__title',
    price: '.cart-items__price',
    removeBtn: '.cart-items__remove',
    wrapper: '.cart-items__wrapper',
  };
 
  const CSS = `
    .cart-items__table {
      display: block !important;
      position: absolute !important;
      opacity: 0 !important;
      pointer-events: none !important;
      width: 1px !important;
      height: 1px !important;
      overflow: hidden !important;
      clip: rect(0,0,0,0) !important;
    }
 
    .cart-visual {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }
 
    .cart-visual__group {
      background-color: #e8e8e4;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10);
    }
 
    .cart-visual__img-mobile {
      width: 100%;
      position: relative;
    }
 
    .cart-visual__img-mobile img {
      width: 100%;
      height: 220px;
      object-fit: cover;
      display: block;
      mix-blend-mode: multiply;
    }
 
    .cart-visual__btn-remove--mobile {
      position: absolute;
      top: 8px;
      right: 8px;
      background: rgba(232, 232, 228, 0.9);
      border: none;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: var(--color-foreground, #000);
      backdrop-filter: blur(4px);
      z-index: 2;
    }
 
    .cart-visual__btn-remove--mobile svg { width: 18px; height: 18px; }
    .cart-visual__btn-remove--mobile:hover { background: rgba(232, 232, 228, 1); }
 
    .cart-visual__img-desktop { display: none; }
    .cart-visual__btn-remove--desktop { display: none; }
 
    .cart-visual__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;
      gap: 8px;
    }
 
    .cart-visual__row-info { flex: 1; min-width: 0; }
 
    .cart-visual__row-title {
      font-size: 16px;
      font-weight: 600;
      color: rgb(0, 0, 0);
      margin: 0;
      overflow-wrap: break-word;
    }
 
    .cart-visual__row-label { font-weight: 400; color: rgba(0, 0, 0, 0.45); }
 
    .cart-visual__row-variant {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.55);
      margin: 2px 0 0;
      overflow-wrap: break-word;
    }
 
    .cart-visual__row-upgrade-title {
      font-size: 16px;
      font-weight: 600;
      color: rgb(0, 0, 0);
      margin: 0;
    }
 
    .cart-visual .cart-item__upgrade-desc {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.55);
      margin: 2px 0 0;
    }
 
    /* Texto de especificação — aparece embutido abaixo da descrição, sem caixa/sombra.
       Usa a técnica de grid-template-rows (0fr → 1fr) em vez de max-height, que é
       mais leve pro navegador animar e evita travadinhas na transição. */
    .cart-visual .cart-item__spec-wrapper {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.45s ease;
    }
 
    .cart-visual .cart-item__spec-wrapper--open {
      grid-template-rows: 1fr;
    }
 
    .cart-visual .cart-item__spec-text {
      font-size: 13px;
      font-weight: 400;
      line-height: 1.45;
      color: rgba(0, 0, 0, 0.7);
      max-width: 34ch;
      margin: 0;
      min-height: 0;
      overflow: hidden;
    }
 
    .cart-visual .cart-item__spec-wrapper--open .cart-item__spec-text {
      margin-top: 6px;
    }
 
    .cart-visual__row-price {
      font-size: 16px;
      font-weight: 600;
      color: rgb(0, 0, 0);
      white-space: nowrap;
      text-align: right;
      min-width: 70px;
    }
 
    /* Ícone (i) de especificações */
    .cart-item__info-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 13px;
      height: 13px;
      flex-shrink: 0;
      border-radius: 50%;
      border: none;
      background: #555555;
      color: #ffffff;
      font-size: 9px;
      font-style: normal;
      font-weight: 700;
      line-height: 1;
      cursor: pointer;
      padding: 0;
      vertical-align: middle;
      margin-left: 6px;
    }
 
    .cart-item__info-icon:hover {
      background: #3d3d3d;
    }
 
    @media screen and (min-width: 990px) {
      .cart-visual__img-mobile { display: none; }
 
      .cart-visual__body { display: flex; align-items: stretch; }
 
      .cart-visual__img-desktop {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 220px;
        padding: 16px;
      }
 
      .cart-visual__img-desktop img {
        width: 188px;
        height: 130px;
        object-fit: cover;
        border-radius: 4px;
        display: block;
        mix-blend-mode: multiply;
      }
 
      .cart-visual__content { flex: 1; display: flex; flex-direction: column; min-width: 0; }
 
      .cart-visual__row { padding: 0; gap: 0; flex: 1; }
      .cart-visual__row--main { padding: 16px 0; }
      .cart-visual__row--upgrade { padding: 12px 0; }
 
      .cart-visual__row-info {
        flex: 1;
        min-width: 140px;
        max-width: 380px;
        padding-right: 16px;
      }
 
      .cart-visual__row-price { min-width: 90px; padding: 0 12px; text-align: left; }
 
      .cart-visual__row-action {
        width: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
 
      .cart-visual__btn-remove--desktop {
        display: flex !important;
        background: transparent;
        border: none;
        cursor: pointer;
        color: var(--color-foreground, #000);
        width: 36px;
        height: 36px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
      }
 
      .cart-visual__btn-remove--desktop:hover { background: rgba(0, 0, 0, 0.06); }
      .cart-visual__btn-remove--desktop svg { width: 18px; height: 18px; }
 
      .cart-visual__row-action--empty { width: 52px; flex-shrink: 0; }
    }
  `;
 
  function injectStyles() {
    if (document.getElementById('cart-visual-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-visual-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }
 
  function getTextContent(el, selector) {
    return el?.querySelector(selector)?.textContent?.trim() || '';
  }
 
  function cloneIcon(removeBtn) {
    const svg = removeBtn?.querySelector('svg');
    return svg ? svg.cloneNode(true) : '🗑';
  }
 
  /**
   * Remove a armação E todos os upgrades vinculados a ela (grau, filtro etc.)
   * numa única chamada à API do carrinho. Os upgrades são linhas separadas
   * sem botão de remover próprio — se removêssemos só a armação, eles
   * ficariam "órfãos" no carrinho (contando no total sem aparecer na tela).
   * @param {string} mainItemKey
   */
  async function removeGroup(mainItemKey) {
    const cartData = window.__cartData;
    const mainItem = cartData?.items?.find((i) => i.key === mainItemKey);
    const groupId = mainItem?.properties?.['_group_id'];
 
    const keysToRemove = [mainItemKey];
    if (groupId && cartData?.items) {
      cartData.items.forEach((item) => {
        if (item.properties?.['_armacao_key'] === groupId) {
          keysToRemove.push(item.key);
        }
      });
    }
 
    const updates = {};
    keysToRemove.forEach((key) => {
      updates[key] = 0;
    });
 
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    } catch (error) {
      console.error('[cart-visual] erro ao remover grupo:', error);
    }
 
    // Recarrega a página pra garantir consistência total entre a tabela
    // nativa (oculta), o resumo lateral e o overlay visual.
    window.location.reload();
  }
 
  function matchSummaryHeight(visual) {
    const lastGroup = visual.querySelector('.cart-visual__group:last-child');
    if (lastGroup) lastGroup.style.minHeight = '';
    if (window.innerWidth < 990) return;
    const summary = document.querySelector('.cart-summary');
    if (!summary) return;
    const summaryHeight = summary.offsetHeight;
    const visualHeight = visual.offsetHeight;
    if (summaryHeight > visualHeight && lastGroup) {
      const diff = summaryHeight - visualHeight;
      lastGroup.style.minHeight = (lastGroup.offsetHeight + diff) + 'px';
    }
  }
 
  function buildGroup(groupEl, cartData) {
    const mainRow = groupEl.querySelector(SELECTORS.mainRow);
    const upgradeRows = groupEl.querySelectorAll(SELECTORS.upgradeRow);
    if (!mainRow) return null;
 
    const imgEl = mainRow.querySelector(SELECTORS.image);
    const removeBtn = mainRow.querySelector(SELECTORS.removeBtn);
    const titleEl = mainRow.querySelector(SELECTORS.title);
    const titleText = titleEl ? titleEl.childNodes[0]?.textContent?.trim() : '';
    const labelEl = titleEl?.querySelector('.cart-item__lente-label');
    const labelText = labelEl?.textContent?.trim() || '';
    const variantText = getTextContent(mainRow, '.cart-items__variants dd') ||
                        getTextContent(mainRow, '.cart-items__variants');
    const priceText = getTextContent(mainRow, SELECTORS.price);
 
    const itemKey = mainRow.dataset.key;
    const cartItem = cartData?.items?.find(i => i.key === itemKey);
    const previewImage = cartItem?.properties?.['_preview_image'] || cartItem?.preview_image;
    const hasDiscount = cartItem && cartItem.original_price > cartItem.final_price;
    const originalFormatted = hasDiscount
      ? 'R$ ' + (cartItem.original_price / 100).toFixed(2).replace('.', ',')
      : null;
 
    const group = document.createElement('div');
    group.className = 'cart-visual__group';
    group.dataset.groupKey = itemKey;
 
    // MOBILE: imagem no topo
    const imgMobileDiv = document.createElement('div');
    imgMobileDiv.className = 'cart-visual__img-mobile';
    if (imgEl) {
      const img = imgEl.cloneNode(true);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (previewImage) img.src = previewImage;
      imgMobileDiv.appendChild(img);
    }
    const removeMobile = document.createElement('button');
    removeMobile.type = 'button';
    removeMobile.className = 'cart-visual__btn-remove--mobile';
    removeMobile.setAttribute('aria-label', 'Remover item');
    removeMobile.appendChild(cloneIcon(removeBtn));
    removeMobile.addEventListener('click', () => {
      removeMobile.disabled = true;
      removeGroup(itemKey);
    });
    imgMobileDiv.appendChild(removeMobile);
    group.appendChild(imgMobileDiv);
 
    // BODY
    const body = document.createElement('div');
    body.className = 'cart-visual__body';
 
    // Coluna imagem desktop
    const imgDesktopDiv = document.createElement('div');
    imgDesktopDiv.className = 'cart-visual__img-desktop';
    if (imgEl) {
      const img = imgEl.cloneNode(true);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (previewImage) img.src = previewImage;
      imgDesktopDiv.appendChild(img);
    }
    body.appendChild(imgDesktopDiv);
 
    // Coluna conteúdo
    const content = document.createElement('div');
    content.className = 'cart-visual__content';
 
    // Linha da armação
    const mainRowEl = document.createElement('div');
    mainRowEl.className = 'cart-visual__row cart-visual__row--main';
 
    const mainInfo = document.createElement('div');
    mainInfo.className = 'cart-visual__row-info';
    mainInfo.innerHTML = `
      <p class="cart-visual__row-title">
        ${titleText}<span class="cart-visual__row-label"> ${labelText}</span>
      </p>
      ${variantText ? `<p class="cart-visual__row-variant">${variantText}</p>` : ''}
    `;
    mainRowEl.appendChild(mainInfo);
 
    const mainPrice = document.createElement('div');
    mainPrice.className = 'cart-visual__row-price';
    if (hasDiscount && originalFormatted) {
      mainPrice.innerHTML = `<s class="cart-visual__original-price">${originalFormatted}</s> ${priceText}`;
    } else {
      mainPrice.textContent = priceText;
    }
    mainRowEl.appendChild(mainPrice);
 
    const mainAction = document.createElement('div');
    mainAction.className = 'cart-visual__row-action';
    const removeDesktop = document.createElement('button');
    removeDesktop.type = 'button';
    removeDesktop.className = 'cart-visual__btn-remove--desktop';
    removeDesktop.setAttribute('aria-label', 'Remover item');
    removeDesktop.appendChild(cloneIcon(removeBtn));
    removeDesktop.addEventListener('click', () => {
      removeDesktop.disabled = true;
      removeGroup(itemKey);
    });
    mainAction.appendChild(removeDesktop);
    mainRowEl.appendChild(mainAction);
 
    content.appendChild(mainRowEl);
 
    // Upgrades
    upgradeRows.forEach((upgradeRow) => {
      const upgradeTitle = getTextContent(upgradeRow, '.cart-item__upgrade-title');
      // Clona o bloco inteiro (descrição + botão (i) + texto de especificação
      // escondido), pra manter o toggle funcionando também na versão visual.
      const upgradeInfoBlockEl = upgradeRow.querySelector('.cart-item__upgrade-info-block');
      const upgradeInfoBlockHTML = upgradeInfoBlockEl ? upgradeInfoBlockEl.outerHTML.trim() : '';
      const upgradePriceText = getTextContent(upgradeRow, SELECTORS.price);
 
      const upgradeRowEl = document.createElement('div');
      upgradeRowEl.className = 'cart-visual__row cart-visual__row--upgrade';
 
      const upgradeInfo = document.createElement('div');
      upgradeInfo.className = 'cart-visual__row-info';
      upgradeInfo.innerHTML = `
        <p class="cart-visual__row-upgrade-title">${upgradeTitle}</p>
        ${upgradeInfoBlockHTML}
      `;
      upgradeRowEl.appendChild(upgradeInfo);
 
      const upgradePrice = document.createElement('div');
      upgradePrice.className = 'cart-visual__row-price';
      upgradePrice.textContent = upgradePriceText;
      upgradeRowEl.appendChild(upgradePrice);
 
      const emptyAction = document.createElement('div');
      emptyAction.className = 'cart-visual__row-action--empty';
      upgradeRowEl.appendChild(emptyAction);
 
      content.appendChild(upgradeRowEl);
    });
 
    body.appendChild(content);
    group.appendChild(body);
 
    return group;
  }
 
  function updateBanner(cartData) {
    const banner = document.querySelector('.cart-banner__sacola');
    if (!banner) return;
    const originalTotal = cartData.original_total_price;
    const currentTotal = cartData.total_price;
    const money = (cents) => 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    if (originalTotal > currentTotal) {
      banner.innerHTML = `Sua sacola:&nbsp;<s class="cart-banner__original">${money(originalTotal)}</s>&nbsp;por&nbsp;<strong>${money(currentTotal)}</strong>`;
    } else {
      banner.innerHTML = `Sua sacola:&nbsp;<strong>${money(currentTotal)}</strong>`;
    }
  }
 
  // Toggle do texto de especificação (ícone "i" nas linhas de upgrade).
  // O texto já está no DOM, escondido por CSS (max-height/opacity); o clique só
  // alterna uma classe que dispara a transição, sem popover flutuante.
 
  let infoToggleEventsBound = false;
 
  function initInfoToggleEvents() {
    if (infoToggleEventsBound) return;
    infoToggleEventsBound = true;
 
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('.cart-item__info-icon');
      if (!button) return;
 
      event.preventDefault();
      event.stopPropagation();
 
      const block = button.closest('.cart-item__upgrade-info-block');
      const wrapper = block?.querySelector('.cart-item__spec-wrapper');
      if (!wrapper) return;
 
      const isOpen = wrapper.classList.contains('cart-item__spec-wrapper--open');
      if (isOpen) {
        wrapper.classList.remove('cart-item__spec-wrapper--open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        wrapper.classList.add('cart-item__spec-wrapper--open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  }
 
  function render() {
    const table = document.querySelector(SELECTORS.table);
    if (!table) return;
    const wrapper = table.closest('.cart-items');
    if (!wrapper) return;
    const groups = table.querySelectorAll(SELECTORS.group);
    if (!groups.length) return;
 
    const cartData = window.__cartData || null;
 
    wrapper.querySelector('.cart-visual')?.remove();
 
    const visual = document.createElement('div');
    visual.className = 'cart-visual';
 
    groups.forEach((group) => {
      const groupEl = buildGroup(group, cartData);
      if (groupEl) visual.appendChild(groupEl);
    });
 
    wrapper.appendChild(visual);
    requestAnimationFrame(() => matchSummaryHeight(visual));
  }
 
  function init() {
    if (!document.querySelector(SELECTORS.table)) return;
    injectStyles();
    render();
    initInfoToggleEvents();
 
    document.addEventListener('cart:updated', render);
    document.addEventListener('cart:refresh', render);
 
    let isRendering = false;
    const cartItemsObserver = new MutationObserver((mutations) => {
      if (isRendering) return;
 
      const visualRemoved = mutations.some(m =>
        Array.from(m.removedNodes).some(n => n.classList?.contains('cart-visual'))
      );
      if (!visualRemoved) return;
 
      isRendering = true;
 
      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          window.__cartData = cartData;
          updateBanner(cartData);
 
          const existingVisual = document.querySelector('.cart-visual');
          if (existingVisual) {
            cartData.items.forEach(item => {
              const group = existingVisual.querySelector(`[data-group-key="${item.key}"]`);
              if (!group) return;
              const preview = item.properties?.['_preview_image'];
              if (preview) {
                group.querySelectorAll('img').forEach(img => {
                  img.src = preview;
                  img.removeAttribute('srcset');
                });
              }
            });
            isRendering = false;
          } else {
            setTimeout(() => {
              render();
              isRendering = false;
            }, 100);
          }
        });
    });
 
    const cartItemsEl = document.querySelector('.cart-items.spacing-style');
    if (cartItemsEl) {
      cartItemsObserver.observe(cartItemsEl, { childList: true });
    }
 
    window.addEventListener('resize', () => {
      const visual = document.querySelector('.cart-visual');
      if (visual) matchSummaryHeight(visual);
    });
  }
 
  window.initCartVisual = init;
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();
 